import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import ModeNightRoundedIcon from '@mui/icons-material/ModeNightRounded';
import CasesRoundedIcon from '@mui/icons-material/CasesRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import { webPage, smartphone, webDevelopment, css, sass, express, html, javascript, mongo, nodeJs, react, redux, reactNative, github } from '../assets';

export const navlinks = [
    {name: 'Home', path: 'home'},
    {name: 'Skills', path: 'skills'},
    {name: 'Projects', path: 'projects'},
    {name: 'Contact', path: 'contact'},
]

export const skillsBar = [
    {title: 'Web Design', description: "A significant section of my work involves frontend development, and ensure it is responsive and visually appealing.", image: webPage},
    {title: 'Web Development', description: 'Blending frontend and backend expertise to create versatile, end-to-end web solutions, bridging user experience and system functionality.', image: webDevelopment},
    {title: 'Mobile App Development', description: 'Using frontend and backend knowledge to craft comprehensive, user-friendly, and high-performance mobile applications.', image: smartphone},
]

// export const projects = [
//     {title: 'site name', link: 'https://www.google.com/', image: work1},
//     {title: 'site name', link: 'https://www.google.com/', image: work2},
//     {title: 'site name', link: 'https://www.google.com/', image: work3},
//     {title: 'site name', link: 'https://www.google.com/', image: work4},
//     {title: 'site name', link: 'https://www.google.com/', image: work5},
// ]

export const techStackImgs = [
    {title: 'Html', image: html},
    {title: 'Css', image: css},
    {title: 'sass', image: sass},
    {title: 'Javascript', image: javascript},
    {title: 'React', image: react},
    {title: 'React Native', image: reactNative},
    {title: 'Redux', image: redux},
    {title: 'Node JS', image: nodeJs},
    {title: 'Express', image: express},
    {title: 'MongoDB', image: mongo},
    {title: 'Github', image: github},
]

export {
    LightModeRoundedIcon,
    ModeNightRoundedIcon,
    MenuRoundedIcon,
    CasesRoundedIcon,
    BadgeRoundedIcon,
    LinkRoundedIcon,
    MoreVertRoundedIcon,
    CloseRoundedIcon,
    KeyboardArrowUpRoundedIcon,
}